(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
(function () {
  var STORAGE_KEY = 'announcement-bar-dismissed';

  function updateHeight() {
    var el = document.querySelector('.js-announcement-bar:not([hidden])');
    document.documentElement.style.setProperty('--header-announcement-bar-height', (el ? el.offsetHeight : 0) + 'px');
  }

  function init() {
    var bar = document.querySelector('.js-announcement-bar');
    if (!bar) return;

    if (localStorage.getItem(STORAGE_KEY) === bar.dataset.announcementText) {
      bar.hidden = true;
      updateHeight();
      return;
    }

    bar.querySelector('.js-announcement-bar-close').addEventListener('click', function () {
      localStorage.setItem(STORAGE_KEY, bar.dataset.announcementText);
      bar.hidden = true;
      updateHeight();
    });

    updateHeight();
  }

  window.addEventListener('resize', updateHeight);
  init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
(function () {
  const panel = document.getElementById('cart-drawer');
  if (!panel) return;

  const panelInner = panel.querySelector('.drawer__inner');

  // Close all other open drawers, open the cart, lock scroll
  function open() {
    document.querySelectorAll('.drawer[aria-hidden="false"]').forEach(function (el) {
      if (el !== panel) el.setAttribute('aria-hidden', 'true');
    });
    panel.setAttribute('aria-hidden', 'false');
    if (panelInner) panelInner.inert = false;
    document.body.style.overflow = 'hidden';
    applyAddedStates();
  }

  // Close the cart and restore scroll if no other drawer is open
  function close() {
    panel.setAttribute('aria-hidden', 'true');
    if (panelInner) panelInner.inert = true;
    if (!document.querySelector('.drawer[aria-hidden="false"]')) document.body.style.overflow = '';
  }

  // Sync item count on all cart toggles and inside the drawer header
  function updateBadge(count) {
    document.querySelectorAll('.js-cart-toggle').forEach(function (toggle) {
      var sup = toggle.querySelector('.js-cart-count');
      sup.textContent = count;
    });

    var countEl = panel.querySelector('.js-cart-count');
    if (countEl) countEl.textContent = '(' + count + ')';
  }

  const addedSampleVariants = []; // ordered FIFO, max 2

  // Mark sample cards as added and inject remove buttons (merges in-memory FIFO list with DOM state)
  function applyAddedStates() {
    const samplesEl = panel.querySelector('.cart-samples');
    const domVariants = samplesEl
      ? (samplesEl.dataset.sampleVariants || '').split(',').filter(Boolean)
      : [];
    const removeLabel = samplesEl ? (samplesEl.dataset.removeLabel || 'Retirer') : 'Retirer';
    const allVariants = addedSampleVariants.concat(
      domVariants.filter(function (id) { return addedSampleVariants.indexOf(id) === -1; })
    );
    panel.querySelectorAll('#samples-drawer .product-card').forEach(function (card) {
      card.classList.remove('is-added');
      var existingBtn = card.querySelector('.js-cart-samples-remove');
      if (existingBtn) existingBtn.remove();
    });
    allVariants.forEach(function (variantId) {
      var input = panel.querySelector('#samples-drawer [name="id"][value="' + variantId + '"]');
      if (!input) return;
      var card = input.closest('.product-card');
      card.classList.add('is-added');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cart-samples__remove-btn btn btn--link js-cart-samples-remove';
      btn.textContent = removeLabel;
      btn.dataset.removeVariant = variantId;
      card.querySelector('.product-card__content').appendChild(btn);
    });
  }

  // Swap the drawer footer from a freshly parsed document (handles appear/disappear)
  function updateFooter(doc) {
    const cartInner = panel.querySelector(':scope > .drawer__inner');
    const newFooter = doc.querySelector('#cart-drawer > .drawer__inner > footer');
    const currentFooter = cartInner ? cartInner.querySelector(':scope > footer') : null;
    if (newFooter && currentFooter) {
      currentFooter.innerHTML = newFooter.innerHTML;
    } else if (newFooter && cartInner) {
      cartInner.appendChild(newFooter);
    } else if (currentFooter) {
      currentFooter.remove();
    }
  }

  // Set quantity to 0 for the given variant IDs via /cart/update.js
  function removeSampleVariants(variantIds) {
    if (!variantIds.length) return Promise.resolve();
    var updates = {};
    variantIds.forEach(function (id) { updates[id] = 0; });
    return fetch('/cart/update.js', {
      body: JSON.stringify({ updates: updates }),
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
    });
  }

  // Return the subset of offered sample variants that are currently in the cart
  function getSampleVariantsInCart() {
    var offeredVariants = Array.from(
      panel.querySelectorAll('#samples-drawer [name="id"]')
    ).map(function (input) { return input.value; });
    if (!offeredVariants.length) return Promise.resolve([]);
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cartData) {
        return cartData.items
          .filter(function (item) { return offeredVariants.indexOf(String(item.variant_id)) !== -1; })
          .map(function (item) { return String(item.variant_id); });
      });
  }

  // Bring free gift quantities down to the maximum the cart total allows, resolved by Liquid
  // (0 below the threshold). Gifts are never added here: the customer adds them from the
  // gifts drawer.
  function syncGifts() {
    const updates = {};
    var mutate = false;
    panel.querySelectorAll('.js-cart-gift').forEach(function (gift) {
      const quantity = Number(gift.dataset.quantity);
      const max = Number(gift.dataset.max);
      if (quantity <= max) return;
      updates[gift.dataset.variantId] = max;
      mutate = true;
    });
    if (!mutate) return;
    fetch('/cart/update.js', {
      body: JSON.stringify({ updates: updates }),
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
    }).then(function (res) {
      // A refused update (422) is tried again on the next refresh
      if (res.ok) refreshCart();
    });
  }

  // Full re-render of the drawer body; auto-removes samples if the threshold is no longer met,
  // and free gifts beyond what the new total allows
  function refreshCart() {
    fetch('/cart?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        const html = data['cart-drawer'];
        if (!html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const willHaveSamples = !!doc.querySelector('.cart-samples');

        // Capture offered variants BEFORE replacing the DOM (samples-drawer will be gone after)
        const offeredVariants = Array.from(
          panel.querySelectorAll('#samples-drawer [name="id"]')
        ).map(function (input) { return input.value; });

        const newBody = doc.querySelector('.drawer__body');
        const currentBody = panel.querySelector('.drawer__body');
        if (newBody && currentBody) currentBody.innerHTML = newBody.innerHTML;

        document.dispatchEvent(new CustomEvent('cart:refresh'));
        updateFooter(doc);

        const countEl = doc.querySelector('[data-cart-count]');
        if (countEl) updateBadge(parseInt(countEl.dataset.cartCount, 10));

        if (!willHaveSamples && offeredVariants.length > 0) {
          addedSampleVariants.splice(0);
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cartData) {
              var ids = cartData.items
                .filter(function (item) { return offeredVariants.indexOf(String(item.variant_id)) !== -1; })
                .map(function (item) { return String(item.variant_id); });
              if (ids.length > 0) removeSampleVariants(ids).then(function () { refreshCart(); });
            });
        }

        syncGifts();
      });
  }

  // Partial refresh: only updates the cart list, samples and gifts texts, gifts button label,
  // gifts list and footer (used after changing a sample or a gift, so their drawer stays open)
  function refreshCartItems() {
    return fetch('/cart?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        const html = data['cart-drawer'];
        if (!html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const newList = doc.querySelector('.cart-list');
        const currentList = panel.querySelector('.cart-list');
        if (newList && currentList) currentList.replaceWith(newList);

        const newSamplesText = doc.querySelector('.cart-samples__text');
        const currentSamplesText = panel.querySelector('.cart-samples__text');
        if (newSamplesText && currentSamplesText) currentSamplesText.innerHTML = newSamplesText.innerHTML;

        const newSamplesEl = doc.querySelector('.cart-samples');
        const currentSamplesEl = panel.querySelector('.cart-samples');
        if (newSamplesEl && currentSamplesEl) {
          currentSamplesEl.dataset.sampleVariants = newSamplesEl.dataset.sampleVariants || '';
        }

        const newGiftsText = doc.querySelector('.cart-gifts__text');
        const currentGiftsText = panel.querySelector('.cart-gifts__text');
        if (newGiftsText && currentGiftsText) currentGiftsText.innerHTML = newGiftsText.innerHTML;

        // Label only: the button keeps its aria-expanded while the gifts drawer is open
        const newGiftsButton = doc.querySelector('.cart-gifts__button');
        const currentGiftsButton = panel.querySelector('.cart-gifts__button');
        if (newGiftsButton && currentGiftsButton) currentGiftsButton.textContent = newGiftsButton.textContent;

        const newGiftsList = doc.querySelector('.cart-gifts__list');
        const currentGiftsList = panel.querySelector('.cart-gifts__list');
        if (newGiftsList && currentGiftsList) currentGiftsList.replaceWith(newGiftsList);

        updateFooter(doc);

        const countEl = doc.querySelector('[data-cart-count]');
        if (countEl) updateBadge(parseInt(countEl.dataset.cartCount, 10));

        applyAddedStates();
      });
  }

  // External refresh trigger
  document.addEventListener('cart:add', function () { refreshCart(); open(); });

  // Toggle cart icon
  document.querySelectorAll('.js-cart-toggle').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      panel.getAttribute('aria-hidden') === 'false' ? close() : open();
    });
  });

  // Add to cart intercept
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!form.matches('[action="/cart/add"]')) return;
    e.preventDefault();
    const inSamples = !!form.closest('#samples-drawer');
    const variantInput = form.querySelector('[name="id"]');
    const submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;
    fetch('/cart/add.js', { body: new FormData(form), method: 'POST' })
      .then(function (res) {
        if (!inSamples) {
          refreshCart();
          open();
          if (submitBtn) submitBtn.disabled = false;
          return;
        }

        const variantId = variantInput ? variantInput.value : null;
        return getSampleVariantsInCart().then(function (cartSampleVariants) {
          // The validation function caps samples at 2: adding a 3rd is rejected
          // (422). Mirror the old FIFO by dropping the oldest sample and adding
          // the new one in a single atomic /cart/update.js (never 3 at once).
          var exceeds = res.status === 422 || cartSampleVariants.length > 2;
          var updates = {};
          var mutate = false;

          if (exceeds) {
            var toRemove = cartSampleVariants.find(function (id) {
              return id !== variantId && addedSampleVariants.indexOf(id) === -1;
            }) || cartSampleVariants.find(function (id) { return id !== variantId; });
            if (toRemove) {
              var idx = addedSampleVariants.indexOf(toRemove);
              if (idx !== -1) addedSampleVariants.splice(idx, 1);
              updates[toRemove] = 0;
              mutate = true;
            }
            // On 422 the new sample was rejected → add it in the same update.
            if (res.status === 422 && variantId) {
              updates[variantId] = 1;
              mutate = true;
            }
          }

          if (variantId && addedSampleVariants.indexOf(variantId) === -1) {
            addedSampleVariants.push(variantId);
          }

          var applied = mutate
            ? fetch('/cart/update.js', {
                body: JSON.stringify({ updates: updates }),
                headers: { 'Content-Type': 'application/json' },
                method: 'POST',
              })
            : Promise.resolve();
          return applied.then(function () { refreshCartItems(); });
        });
      });
  });

  // Remove sample from samples drawer
  panel.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('.js-cart-samples-remove');
    if (!removeBtn) return;
    var variantId = removeBtn.dataset.removeVariant;
    var idx = addedSampleVariants.indexOf(variantId);
    if (idx !== -1) addedSampleVariants.splice(idx, 1);
    removeSampleVariants([variantId]).then(function () {
      var card = removeBtn.closest('.product-card');
      if (card) {
        var form = card.querySelector('form');
        if (form) {
          var btn = form.querySelector('[type="submit"]');
          if (btn) btn.disabled = false;
        }
      }
      refreshCartItems();
    });
  });

  // Change a free gift quantity from the gifts drawer (target quantity resolved by Liquid)
  panel.addEventListener('click', function (e) {
    const btn = e.target.closest('.js-cart-gift-quantity');
    if (!btn) return;
    const gift = btn.closest('.js-cart-gift');
    const variantId = gift.dataset.variantId;
    const updates = {};
    updates[variantId] = Number(btn.dataset.quantity);
    gift.querySelectorAll('.js-cart-gift-quantity').forEach(function (el) { el.disabled = true; });
    fetch('/cart/update.js', {
      body: JSON.stringify({ updates: updates }),
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
    })
      .then(refreshCartItems)
      .then(function () {
        // The list was re-rendered: give focus back to the same button, or to the other one
        // when the new quantity disabled it
        const buttons = Array.from(panel.querySelectorAll(
          '.js-cart-gift[data-variant-id="' + variantId + '"] .js-cart-gift-quantity:not(:disabled)'
        ));
        const next = buttons.find(function (el) { return el.id === btn.id; }) || buttons[0];
        if (next) next.focus();
      });
  });

  // Change a cart line and cascade the delta on its optional additional product variant
  function changeLineWithAdditional(srcEl, newQty) {
    const line = Number(srcEl.dataset.cartLine);
    const additionalVariantId = srcEl.dataset.additionalProductVariantId;
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        const aItem = cart.items[line - 1];
        const aOldQty = aItem ? aItem.quantity : 0;
        const delta = newQty - aOldQty;
        return fetch('/cart/change.js', {
          body: JSON.stringify({ line: line, quantity: newQty }),
          headers: { 'Content-Type': 'application/json' },
          method: 'POST',
        }).then(function (res) {
          // The cart/checkout validation function returns 422 for any change
          // that would leave the cart with only samples below the minimum.
          // Redo the change atomically via a single /cart/update.js that also
          // clears every sample, so the cart never lands in an invalid state.
          if (res.status === 422) {
            const updates = {};
            if (aItem) updates[aItem.variant_id] = newQty;
            if (additionalVariantId && delta !== 0) {
              const addId = parseInt(additionalVariantId, 10);
              const bItem = cart.items.find(function (i) { return i.variant_id === addId; });
              const bOldQty = bItem ? bItem.quantity : 0;
              const bNewQty = Math.max(0, bOldQty + delta);
              if (bNewQty !== bOldQty) updates[addId] = bNewQty;
            }
            const offeredSamples = Array.from(
              panel.querySelectorAll('#samples-drawer [name="id"]')
            ).map(function (input) { return Number(input.value); });
            cart.items.forEach(function (i) {
              if (offeredSamples.indexOf(i.variant_id) !== -1) updates[i.variant_id] = 0;
            });
            addedSampleVariants.splice(0);
            return fetch('/cart/update.js', {
              body: JSON.stringify({ updates: updates }),
              headers: { 'Content-Type': 'application/json' },
              method: 'POST',
            });
          }
          if (!additionalVariantId || delta === 0) return;
          const addId = parseInt(additionalVariantId, 10);
          const bItem = cart.items.find(function (i) { return i.variant_id === addId; });
          const bOldQty = bItem ? bItem.quantity : 0;
          const bNewQty = Math.max(0, bOldQty + delta);
          if (bNewQty === bOldQty) return;
          if (bItem) {
            return fetch('/cart/change.js', {
              body: JSON.stringify({ id: String(addId), quantity: bNewQty }),
              headers: { 'Content-Type': 'application/json' },
              method: 'POST',
            });
          }
          return fetch('/cart/add.js', {
            body: JSON.stringify({ items: [{ id: addId, quantity: bNewQty }] }),
            headers: { 'Content-Type': 'application/json' },
            method: 'POST',
          });
        });
      });
  }

  // Remove item from within the panel (cascades the additional product)
  panel.addEventListener('click', function (e) {
    const link = e.target.closest('.js-cart-remove');
    if (!link) return;
    e.preventDefault();
    changeLineWithAdditional(link, 0).then(refreshCart);
  });

  // Quantity change (cascades the additional product)
  panel.addEventListener('change', function (e) {
    const select = e.target.closest('.js-cart-qty');
    if (!select) return;
    changeLineWithAdditional(select, Number(select.value)).then(refreshCart);
  });

  // A cart changed outside the drawer (cart page, checkout) may hold more gifts than its total allows
  syncGifts();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
/**
 * Menu — sticky header + body class toggles on open/close.
 *
 * Listens to custom events dispatched by components (dropdown, drawer, modal).
 */
const header = document.querySelector('header[role="banner"]');

class Menu {
  constructor(elm) {
    this.elm = elm;
    this.previousY = 0;
    this.y = 0;
    this.classSticky = 'is-sticky';
    this.classScrollingDown = 'is-scrolling-down';
    this.classMenuOpen = 'is-menu-open';
    this.classDropdownMenuOpen = 'is-dropdown-menu-open';
    this.componentElm = document.getElementById('navigation');
    this.dropdowns = this.elm.querySelectorAll('.js-dropdown-toggle');
    this.offset = this.elm.offsetHeight;

    this._initDropdowns();
    this._initNavigation();
    this._initSticky();
  }

  _initDropdowns() {
    this.dropdowns.forEach((dropdown) => {
      this._toggleClass(
        dropdown,
        this.classDropdownMenuOpen,
        ['component:shown'],
        ['component:hidden']
      );
    });
  }

  _initNavigation() {
    if (this.componentElm) {
      this._toggleClass(
        this.componentElm,
        this.classMenuOpen,
        ['drawer:shown', 'modal:shown'],
        ['drawer:hidden', 'modal:hidden']
      );
    }
  }

  _initSticky() {
    ['scroll', 'touchmove'].forEach((event) => {
      window.addEventListener(event, () => {
        this.y = window.scrollY;

        this.elm.classList.toggle(this.classSticky, this.y > this.offset);
        document.documentElement.classList.toggle(
          this.classScrollingDown,
          this.y > this.previousY && this.y > this.offset
        );

        this.previousY = this.y;
      });
    });
  }

  _toggleClass(elm, toggleClass, showEvents, hideEvents) {
    showEvents.forEach((e) => {
      elm.addEventListener(e, () => {
        document.documentElement.classList.add(toggleClass);
      });
    });

    hideEvents.forEach((e) => {
      elm.addEventListener(e, () => {
        document.documentElement.classList.remove(toggleClass);
      });
    });
  }
}

if (header) {
  new Menu(header);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modal-redirect"]) return;
  try {
    
  (function () {
    function parseAlternates(value) {
      try {
        return JSON.parse(value || '[]');
      } catch (e) {
        return [];
      }
    }

    function originOf(url) {
      try {
        return new URL(url, window.location.origin).origin;
      } catch (e) {
        return '';
      }
    }

    // Two alternates can share a domain (fr-FR and en both live on the world store):
    // the browser languages, in their own order, decide which one the visitor is offered.
    function preferredAlternate(candidates) {
      const languages = navigator.languages || [navigator.language || ''];

      for (const language of languages) {
        const wanted = language.toLowerCase();

        const exact = candidates.find(function (candidate) {
          return candidate.code.toLowerCase() === wanted;
        });
        if (exact) return exact;

        const sameLanguage = candidates.find(function (candidate) {
          return candidate.code.toLowerCase().split('-')[0] === wanted.split('-')[0];
        });
        if (sameLanguage) return sameLanguage;
      }

      return candidates[0] || null;
    }

    function initRedirectModal(container) {
      const STORAGE_KEY = container.dataset.storageKey || 'geo-suggestion-dismissed2';
      const rules = Array.from(container.querySelectorAll('.modal-redirect__rule'));
      const designMode = Boolean(window.Shopify && window.Shopify.designMode);

      // The hreflang alternates of the current page, resolved in Liquid: [{ code, href }]
      const alternates = parseAlternates(container.dataset.alternates);

      // ?geo=US forces the detected country, to test a rule without a VPN.
      // It also bypasses (and never writes) the dismissed flag, so it stays repeatable.
      const forcedCountry = new URLSearchParams(window.location.search).get('geo');

      if (!rules.length) return;

      function isDismissed() {
        try {
          return Boolean(localStorage.getItem(STORAGE_KEY));
        } catch (e) {
          return false;
        }
      }

      function dismiss() {
        try {
          localStorage.setItem(STORAGE_KEY, '1');
        } catch (e) {
          // Private browsing: the suggestion simply shows again next time
        }
      }

      function matches(rule, country) {
        const countries = (rule.dataset.countries || '')
          .split(',')
          .map(function (code) { return code.trim().toUpperCase(); })
          .filter(Boolean);
        const isListed = countries.includes(country);

        // "exclude" turns the list into "every country except these"
        return rule.dataset.match === 'exclude' ? !isListed : isListed;
      }

      function isOtherStore(url) {
        const origin = originOf(url);

        return Boolean(origin) && origin !== window.location.origin;
      }

      // The alternate a rule points to: the code set on the rule, otherwise the alternate
      // served by the same domain as its URL — in the order the browser asks for languages.
      function alternateFor(rule) {
        const code = (rule.dataset.hreflang || '').trim().toLowerCase();

        if (code) {
          const declared = alternates.find(function (alternate) {
            return alternate.code.toLowerCase() === code;
          });

          if (declared) return declared;
        }

        const origin = originOf(rule.dataset.url);
        const candidates = alternates.filter(function (alternate) {
          return originOf(alternate.href) === origin;
        });

        return preferredAlternate(candidates);
      }

      // Where the visitor lands: the page the hreflang declares, its home page otherwise
      function targetUrl(rule) {
        const alternate = alternateFor(rule);
        const target = new URL(alternate ? alternate.href : rule.dataset.url, window.location.origin);
        const search = new URLSearchParams(window.location.search);

        search.delete('geo');
        // The target keeps its own query (a preview_theme_id, typically), the page adds its own
        search.forEach(function (value, key) { target.searchParams.set(key, value); });

        return target.href;
      }

      function openRule(rule) {
        const dialog = rule.querySelector('dialog');
        if (!dialog || dialog.open) return;

        const link = dialog.querySelector('[data-redirect-link]');
        if (link) link.href = targetUrl(rule);

        if (!designMode && !forcedCountry) dialog.addEventListener('close', dismiss, { once: true });

        dialog.showModal();
      }

      async function detectCountry() {
        if (forcedCountry) return forcedCountry;

        const res = await fetch('/browsing_context_suggestions.json');
        const data = await res.json();

        return data?.detected_values?.country?.handle; // ISO code, e.g. "US"
      }

      async function suggestStore() {
        const country = await detectCountry();
        if (!country) return;

        const rule = rules.find(function (candidate) {
          return isOtherStore(candidate.dataset.url) && matches(candidate, country.toUpperCase());
        });

        if (rule) openRule(rule);
      }

      if (designMode) {
        // Theme editor: preview the rule the merchant is editing
        document.addEventListener('shopify:block:select', function (event) {
          const rule = event.target.closest('.modal-redirect__rule');
          if (rule && container.contains(rule)) openRule(rule);
        });

        document.addEventListener('shopify:block:deselect', function (event) {
          const dialog = event.target.querySelector('dialog');
          if (dialog && dialog.open) dialog.close();
        });

        return;
      }

      if (!forcedCountry && isDismissed()) return;

      suggestStore().catch(function () {
        // Geolocation is a nice-to-have: stay silent on network errors
      });
    }

    function initAll(root) {
      root.querySelectorAll('.modal-redirect').forEach(initRedirectModal);
    }

    // Adding or editing a rule re-renders the section, so re-bind the fresh markup
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });

    initAll(document);
  })();

  } catch(e) { console.error(e); }
})();
})();
